import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Funnel } from "lucide-react";
import MessageCard from "../../components/dashboard comp/MessageCard";
import OrderCard from "../../components/dashboard comp/OrderCard";
import FilterModal from "../../components/dashboard comp/FilterModal";

export default function Dashboard() {
  const [activeTab, setActiveTab] = useState("all");
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [filters, setFilters] = useState([]);

  return (
    <motion.div
      className="min-h-screen bg-gradient-to-b from-gray-100 via-green-100 to-green-700 flex flex-col"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      {/* Header */}
      <header className="px-6 py-8">
        <p className="text-2xl font-bold text-black">FINCA</p>
      </header>

      <main className="mx-6">
        {/* Dashboard Title */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.3, duration: 0.5 }}
          className="mb-6"
        >
          <h2 className="font-bold text-4xl">Dashboard</h2>
        </motion.div>

        {/* Registration Requests */}
        <motion.div
          className="mb-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.5 }}
        >
          <p className="font-medium mb-3">Registration requests</p>
          <motion.div
            className="bg-white max-w-md rounded-lg py-4 px-4"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.5, duration: 0.4 }}
          >
            <p className="font-light">
              <span className="font-medium">aada.technology@gmail.com</span> is requesting to register
              <span className="font-medium text-[#8A8A8A] text-sm flex justify-end mt-2">
                10/12/2025
              </span>
            </p>
            <div className="flex gap-4 justify-end mt-2">
              <button className="bg-red-700 text-white px-3 rounded-lg">Decline</button>
              <button className="bg-green-900 text-white px-3 rounded-lg">Accept</button>
            </div>
          </motion.div>
        </motion.div>

        {/* Tabs */}
        <motion.div
          className="flex justify-between items-center mb-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.5 }}
        >
          <div className="flex gap-2">
            <motion.button
              onClick={() => setActiveTab("all")}
              className={`font-bold px-4 py-2 rounded-xl ${activeTab === "all" ? "bg-black text-white" : "bg-white"}`}
            >
              All
            </motion.button>
            <motion.button
              onClick={() => setActiveTab("orders")}
              className={`font-bold px-4 py-2 rounded-xl ${activeTab === "orders" ? "bg-black text-white" : "bg-white"}`}
            >
              Orders
            </motion.button>
            <motion.button
              onClick={() => setActiveTab("messages")}
              className={`font-bold px-4 py-2 rounded-xl ${activeTab === "messages" ? "bg-black text-white" : "bg-white"}`}
            >
              Messages
            </motion.button>
          </div>

          <motion.button
            onClick={() => setIsFilterOpen(true)}
            className="p-2 hover:scale-110 transition-transform flex-shrink-0"
          >
            <Funnel size={24} />
          </motion.button>
        </motion.div>

        {/* Content Cards */}
        <motion.div
          className="bg-white -mt-2 w-full rounded-lg min-h-[350px] px-4 py-4 mb-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.7, duration: 0.5 }}
        >
          <AnimatePresence mode="wait">
            {activeTab === "all" && (
              <motion.div key="all" initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: 20 }} transition={{ duration: 0.3 }}>
                <MessageCard email="aada.technology@gmail.com" message="Hi, I would like to find out what ..." date="06/12/2025" />
              </motion.div>
            )}

            {activeTab === "orders" && (
              <motion.div key="orders" initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: 20 }} transition={{ duration: 0.3 }}>
                <OrderCard orderId="#21FNDFLFE" items="2kg Avocado, ..." date="06/12/2025" />
              </motion.div>
            )}

            {activeTab === "messages" && (
              <motion.div key="messages" initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: 20 }} transition={{ duration: 0.3 }}>
                <MessageCard email="aada.technology@gmail.com" message="Hi, I would like to find out what ..." date="06/12/2025" />
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>
      </main>

      {/* Footer */}
      <motion.footer className="text-center mt-auto pb-6 sm:pb-8 text-white text-xs sm:text-sm px-4">
        <p>Copyright © 2025 AADA. All rights reserved.</p>
      </motion.footer>

      {/* Filter Modal */}
      <FilterModal isOpen={isFilterOpen} onClose={() => setIsFilterOpen(false)} filters={filters} setFilters={setFilters} />
    </motion.div>
  );
}